import { useSelector } from "react-redux";
import { Text, Image, Button, Group, Menu } from "@mantine/core";
import { Trash, Notes, BrandOpenSource, Edit } from "tabler-icons-react";
import see from "../../static/svg/see.svg";
import { CDN_URL } from "../../constant";
import { BsHeart } from "react-icons/bs";
import { Link } from "react-router-dom";
import MenuItem from "../../components/MenuItem";
import deleteExperience from "../../API/deleteExperience";
import editIsDraft from "../../API/editIsDraft";
import editIsPrivate from "../../API/editIsPrivate";
import { useModals } from "@mantine/modals";
import {
	showErrorNotification,
	showSuccessNotification,
} from "../../utils/Notifications";
import getDashboardExperinces from "../../API/getDashboardExperinces";
const DashboardExperiences = ({
	setLoading,
	setmodelData,
	setspaceID,
	setOpened,
	dasboardExpereinces,
	setDasboardExpereinces,
}) => {
	const AccountId = useSelector(
		(state) => state.userInformationReducer.users.AccountId
	);
	const modals = useModals();
	const refresh = async () => {
		const result = await getDashboardExperinces(AccountId);
		setDasboardExpereinces(result);
	};
	const openDeleteModal = (id) => {
		modals.openConfirmModal({
			title: "Please confirm your action",
			centered: true,
			styles: {
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			},
			children: (
				<Text size="sm">
					Are you sure you want to delete this experience?
				</Text>
			),
			labels: { confirm: "Delete", cancel: "Cancel" },
			confirmProps: { color: "red" },
			onConfirm: () => {
				setLoading(true);
				handleDelete(id);
			},
		});
	};

	const handleDelete = async (id) => {
		const result = await deleteExperience(id);
		setLoading(false);
		if (result.status === 200) {
			refresh();
			showSuccessNotification("Delete Successfuly");
		} else {
			showErrorNotification("Error");
		}
	};
	const handlePrivate = async (id, space) => {
		const IsPrivate = space.IsPrivate === 1 ? 0 : 1;
		const notification = IsPrivate === 1 ? "Private" : "Public";
		const result = await editIsPrivate(id, { IsPrivate });
		if (result.status === 200) {
			refresh();
			showSuccessNotification(`${notification} Successfuly`);
		} else {
			showErrorNotification("Error");
		}
	};

	const handleDraft = async (id, space) => {
		const IsDraft = space.IsDraft === 1 ? 0 : 1;
		const notification = IsDraft === 1 ? "Draft" : "UnDraft";
		const result = await editIsDraft(id, { IsDraft });
		if (result.status === 200) {
			refresh();
			showSuccessNotification(`${notification} Successfuly`);
		} else {
			showErrorNotification("Error");
		}
	};
	const handleEdit = async (id, space) => {
		setmodelData(space);
		setspaceID(space.id);
		setOpened(true);
	};
	return (
		<>
			<Group
				mt={10}
				position="left"
				style={{
					marginTop: "1rem",
				}}
			>
				<Text>
					<Image src={see} width={18} mr={-10} />
				</Text>
				<Text style={{ color: "white" }} size="sm">
					MY EXPERIENCES
				</Text>
			</Group>
			<div className="boxes">
				<div className="explore-flexpanel p-0">
					<div className="flexpanel-section">
						{dasboardExpereinces &&
							dasboardExpereinces?.map((element) => (
								<div
									key={element.SpaceId}
									className="flexpanel-item"
									style={{
										marginBottom: "20px",
										height: "250px",
									}}
								>
									<Menu
										offset={1}
										position="bottom-end"
										styles={{
											dropdown: {
												backgroundColor:
													"rgb(9, 37, 78)",
											},
										}}
									>
										<Menu.Target>
											<Button
												style={{
													position: "absolute",
													top: "6px",
													right: "6px",
													padding: "0px",
													background: "none",
													zIndex: "2",
													width: "25px",
													height: "25px",
													backgroundColor:
														"rgba(9, 37, 78,0.75)",
													borderRadius: "50%",
												}}
											>
												⋮
											</Button>
										</Menu.Target>
										<Menu.Dropdown>
											<MenuItem
												Name="Edit"
												Icon={Edit}
												id={element.SpaceId}
												space={element.space}
												menuItemHandler={handleEdit}
											/>
											<MenuItem
												Name={
													element.space.IsDraft === 1
														? "Drafted"
														: "setDraft"
												}
												Icon={Notes}
												id={element.SpaceId}
												space={element.space}
												menuItemHandler={handleDraft}
											/>
											<MenuItem
												Name={
													element.space.IsPrivate ===
													1
														? "Privated"
														: "setPrivate"
												}
												Icon={BrandOpenSource}
												id={element.SpaceId}
												space={element.space}
												menuItemHandler={handlePrivate}
											/>
											<MenuItem
												Name="Delete"
												Icon={Trash}
												id={element.SpaceId}
												space={element.space}
												menuItemHandler={
													openDeleteModal
												}
											/>
										</Menu.Dropdown>
									</Menu>

									<Link
										to="/creator"
										state={{
											space: element.space,
										}}
										style={{
											width: "100%",
											height: "100%",
										}}
									>
										<img
											alt="Thumbnail"
											src={
												CDN_URL +
												(element.space?.ThumbnailUrl
													? element.space
															?.ThumbnailUrl
													: "")
											}
											style={{
												width: "100%",
												height: "100%",
												position: "absolute",
												objectFit: "cover",
											}}
										/>
										<span
											style={{
												position: "absolute",
												bottom: "10px",
												marginLeft: "1rem",
												fontSize: "20px",
												color: "white",
												zIndex: "1",
											}}
										>
											{element.space?.Name
												? element.space?.Name
												: ""}
										</span>
									</Link>
								</div>
							))}
					</div>
				</div>
			</div>
		</>
	);
};

export default DashboardExperiences;
